/* tslint:disable */
/* eslint-disable */
/**
 * Veritable
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 7.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { HTTPValidationError } from '../models';
/**
 * EKYCServiceApi - axios parameter creator
 * @export
 */
export const EKYCServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * creates a stripe\'s identification verification session and returns only the client secret to the frontend :return:
         * @summary create an stripe\'s identification session
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIdentificationSession: async (providerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('createIdentificationSession', 'providerId', providerId)
            const localVarPath = `/api/v1/eKYC/{providerId}`
                .replace(`{${"providerId"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * updates a stripe\'s identification verification status :return:
         * @summary update identification verification status
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchIdentityVerificationStatus: async (providerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('patchIdentityVerificationStatus', 'providerId', providerId)
            const localVarPath = `/api/v1/eKYC/admin/verificationStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (providerId !== undefined) {
                localVarQueryParameter['providerId'] = providerId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * acknowledges a session success and updates the status :return:
         * @summary acknowledge session success
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIdentificationSession: async (providerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('updateIdentificationSession', 'providerId', providerId)
            const localVarPath = `/api/v1/eKYC/{providerId}`
                .replace(`{${"providerId"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EKYCServiceApi - functional programming interface
 * @export
 */
export const EKYCServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EKYCServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * creates a stripe\'s identification verification session and returns only the client secret to the frontend :return:
         * @summary create an stripe\'s identification session
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createIdentificationSession(providerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createIdentificationSession(providerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EKYCServiceApi.createIdentificationSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * updates a stripe\'s identification verification status :return:
         * @summary update identification verification status
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchIdentityVerificationStatus(providerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchIdentityVerificationStatus(providerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EKYCServiceApi.patchIdentityVerificationStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * acknowledges a session success and updates the status :return:
         * @summary acknowledge session success
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateIdentificationSession(providerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateIdentificationSession(providerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EKYCServiceApi.updateIdentificationSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EKYCServiceApi - factory interface
 * @export
 */
export const EKYCServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EKYCServiceApiFp(configuration)
    return {
        /**
         * creates a stripe\'s identification verification session and returns only the client secret to the frontend :return:
         * @summary create an stripe\'s identification session
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIdentificationSession(providerId: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.createIdentificationSession(providerId, options).then((request) => request(axios, basePath));
        },
        /**
         * updates a stripe\'s identification verification status :return:
         * @summary update identification verification status
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchIdentityVerificationStatus(providerId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.patchIdentityVerificationStatus(providerId, options).then((request) => request(axios, basePath));
        },
        /**
         * acknowledges a session success and updates the status :return:
         * @summary acknowledge session success
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIdentificationSession(providerId: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.updateIdentificationSession(providerId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EKYCServiceApi - interface
 * @export
 * @interface EKYCServiceApi
 */
export interface EKYCServiceApiInterface {
    /**
     * creates a stripe\'s identification verification session and returns only the client secret to the frontend :return:
     * @summary create an stripe\'s identification session
     * @param {string} providerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EKYCServiceApiInterface
     */
    createIdentificationSession(providerId: string, options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * updates a stripe\'s identification verification status :return:
     * @summary update identification verification status
     * @param {string} providerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EKYCServiceApiInterface
     */
    patchIdentityVerificationStatus(providerId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * acknowledges a session success and updates the status :return:
     * @summary acknowledge session success
     * @param {string} providerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EKYCServiceApiInterface
     */
    updateIdentificationSession(providerId: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }>;

}

/**
 * EKYCServiceApi - object-oriented interface
 * @export
 * @class EKYCServiceApi
 * @extends {BaseAPI}
 */
export class EKYCServiceApi extends BaseAPI implements EKYCServiceApiInterface {
    /**
     * creates a stripe\'s identification verification session and returns only the client secret to the frontend :return:
     * @summary create an stripe\'s identification session
     * @param {string} providerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EKYCServiceApi
     */
    public createIdentificationSession(providerId: string, options?: RawAxiosRequestConfig) {
        return EKYCServiceApiFp(this.configuration).createIdentificationSession(providerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * updates a stripe\'s identification verification status :return:
     * @summary update identification verification status
     * @param {string} providerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EKYCServiceApi
     */
    public patchIdentityVerificationStatus(providerId: string, options?: RawAxiosRequestConfig) {
        return EKYCServiceApiFp(this.configuration).patchIdentityVerificationStatus(providerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * acknowledges a session success and updates the status :return:
     * @summary acknowledge session success
     * @param {string} providerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EKYCServiceApi
     */
    public updateIdentificationSession(providerId: string, options?: RawAxiosRequestConfig) {
        return EKYCServiceApiFp(this.configuration).updateIdentificationSession(providerId, options).then((request) => request(this.axios, this.basePath));
    }
}

